import { Box } from "@mui/material";
import { observer } from "mobx-react";
import { SwayyPageHeader } from "../components/SwayyPageShell";
import PermissionBlockLabel from "../../../../views/components/common/pop-up/PermissionBlockLabel ";
import { userStore } from "../../../../stores/sharedStores";
import { SwayyEmployeeRoles } from "../../../../models/Employees/SwayyEmployeeRoles";

const SwayyDashboard = () => {
  if (!userStore.hasSwayyPermission(SwayyEmployeeRoles.VIEW_DASHBOARD)) {
    return <PermissionBlockLabel />;
  }

  return (
    <Box sx={{ p: { xs: 0.5, md: 1 } }}>

      <SwayyPageHeader
        module="Overview"
        title="Dashboard"
        description="Your Swayy workspace is ready. Pick a module from the sidebar to keep moving."
      />

    </Box>
  );
};


export default observer(SwayyDashboard);
